const FIELD_VALUES: Record<"API_ACTION", Record<string, string>> = {
  API_ACTION: {
    body: "JSON",
    params: "string",
    headers: "string",
    path: "string",
  },
};

export default FIELD_VALUES;
